import { SIRIValue } from "./SIRIValue";
/* Mapping between mechanism key in Redcap CSV and key in antibiogo export.
 * Read the following like this : 'AntibiogoSIR' : 'RedcapSIR'
 */
export const SIRIMappingEUCAST: Map<string, SIRIValue> = new Map<
  string,
  SIRIValue
>([
  ["S", new SIRIValue("S", "s")],
  ["I", new SIRIValue("I", "i")],
  ["R", new SIRIValue("R", "r")],
  ["NI", new SIRIValue("N/A", "na")],
  ["I", new SIRIValue("I", "i")],
  ["PS", new SIRIValue("N/A", "na")],
  [".", new SIRIValue("N/A", "na")],
  ["ATU", new SIRIValue("N/A", "na")],
  ["Cannot be interpeted", new SIRIValue("N/A", "na")],
  ["Diminished susceptibility", new SIRIValue("I", "i")],
  ["High level resistance", new SIRIValue("R", "r")],
  ["In progress", new SIRIValue("N/A", "na")],
  ["Intermediate", new SIRIValue("I", "i")],
  ["Intermediate level resistance", new SIRIValue("R", "r")],
  ["Low level resistance", new SIRIValue("R", "r")],
  ["MIC = @mic mg/l", new SIRIValue("N/A", "na")],
  ["No Eucast Breakpoint", new SIRIValue("N/A", "na")],
  ["NOT CORRECT", new SIRIValue("N/A", "na")],
  ["request M.I.C.", new SIRIValue("Request M.I.C.", "mic")],
  ["Resistant", new SIRIValue("R", "r")],
  ["SUSCEPTIBLE", new SIRIValue("S", "s")],
  ['Susceptible "with reserve"', new SIRIValue("S", "s")],
  ["SUSCEPTIBLE, INCREASED EXPOSURE", new SIRIValue("I", "i")]
]);
